import type { ReactNode } from 'react';
import { cn } from './cn';

export interface StatProps {
  label: string;
  value: ReactNode;
  hint?: string;
  className?: string;
}

export function Stat({ label, value, hint, className }: StatProps) {
  return (
    <div
      className={cn(
        'rounded-stitch-xl border border-stitch-border bg-stitch-surface px-4 py-3 shadow-stitch-card',
        className,
      )}
    >
      <p className="text-xs font-medium uppercase tracking-wide text-stitch-muted">
        {label}
      </p>
      <p className="mt-1 text-2xl font-bold tabular-nums text-stitch-fg">{value}</p>
      {hint && <p className="mt-1 text-xs text-stitch-muted">{hint}</p>}
    </div>
  );
}
